import { generatePath, To } from 'react-router-dom'

import { Table, usePagination } from 'components/Table'
import { PaginationProps } from 'components/Table/Pagination'
import { useSort } from 'components/Table/Sort'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { calculatePagination } from 'providers/tanstack-query/table'
import { ROUTES } from 'routes'
import { DEFAULT_SORT, SORTABLE_COLUMNS } from './constants'
import { useGetBidders } from './hooks/useGetBidders'
import { SortBy } from './hooks/useGetBidders/types'
import { BiddersForTable, BiddersTableProps } from './types'
import { useColumns } from './useColumns'

export const BiddersTable = ({ filters }: BiddersTableProps): JSX.Element => {
  const { workspaceId } = useWorkspaceParam()
  const columns = useColumns()
  const { page, rowsPerPage, setPage, ...usePaginationProps } = usePagination({
    resetOnChange: [filters],
  })
  const { props: sortProps, sort } = useSort<BiddersForTable, SortBy>(
    DEFAULT_SORT,
    SORTABLE_COLUMNS,
  )

  const { bidders, count, loading } = useGetBidders({
    filters,
    sort,
    ...calculatePagination({ page, rowsPerPage }),
  })

  const handleRowClick = ({ id }: BiddersForTable): To =>
    generatePath(ROUTES.GLOBAL_SETUP.PREBID.BIDDERS.EDIT, {
      id,
      tab: 'general',
      workspaceId,
    })

  const paginationProps: PaginationProps = {
    count,
    page,
    rowsPerPage,
    setPage,
    ...usePaginationProps,
  }

  return (
    <Table<BiddersForTable>
      columns={columns}
      data={bidders}
      loading={loading}
      meta={{ stickyHeader: true }}
      onClickRow={handleRowClick}
      pagination={paginationProps}
      sort={sortProps}
    />
  )
}
